import {Component, Input, OnInit, ElementRef} from '@angular/core';
import {Storyboard} from 'storyboard-renderer';
import {Template} from "../../../template/shared/template";
import {LocalStorageService} from "angular-2-local-storage";

@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit {

  @Input() storyboard: Storyboard;
  tutorial = true;
  aspectRatio = 1;

  constructor(private element: ElementRef, private localStorageService: LocalStorageService) {
    this.element = element;
  }

  ngOnInit() {
    if (this.localStorageService.get('tutorial')) {
      this.tutorial = false;
    }

    this.aspectRatio = this.storyboard.getAspectRatio()
  }

  isAllowedToShowPreview() {
    return (this.storyboard && this.storyboard.attached_audio) || this.storyboard.constructor.name === Template.name;
  }

  closeTutorial() {
    this.localStorageService.set('tutorial', 1);
    this.tutorial = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/preview/preview.component.ts